export const mepRef20Options = [
  'evacuation centre',
  'friends or family outside the warning area',
  'shops, restaurants or other facilities outside the warning area',
  'other safe place',
  'other',
] as const;

export const mepRef20OptionsLabels: Record<(typeof mepRef20Options)[number], string> = {
  'evacuation centre': 'Evacuation centre',
  'friends or family outside the warning area': 'Friends or family outside the warning area',
  'shops, restaurants or other facilities outside the warning area': 'Shops, restaurants or other facilities outside the warning area',
  'other safe place': 'Other safe place',
  other: 'Other',
};
